/**
 * HUB-C — Liste retraits caisse (consultation, période filtres Activité).
 */
import React from 'react';
import { Banknote } from 'lucide-react';
import { formatPaymentDate } from '../../utils/paiements/paiementsDisplay';

export default function ActivitePaiementsRetraitsList({ retraits, loading, testIdPrefix = 'activite-paiements' }) {
  if (loading) {
    return (
      <div className="flex justify-center py-12" data-testid={`${testIdPrefix}-retraits-loading`}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!retraits?.length) {
    return (
      <div className="text-center py-12 text-[var(--rm-gray-500)]" data-testid={`${testIdPrefix}-retraits-empty`}>
        <Banknote className="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>Aucun retrait pour cette période</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-retraits-list`}>
      {retraits.map((retrait) => (
        <article
          key={retrait.ref_vente}
          className="rounded-xl border p-4"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
          data-testid={`${testIdPrefix}-retrait-${retrait.ref_vente}`}
        >
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <span className="font-mono text-sm font-bold text-[var(--rm-white)]">{retrait.ref_vente}</span>
                <span className="rm-badge rm-badge--danger">retrait</span>
              </div>
              <p className="text-sm text-[var(--rm-gray-400)]">{retrait.designation || retrait.motif || 'Retrait espèces'}</p>
              <p className="text-xs text-[var(--rm-gray-500)] mt-1">
                {formatPaymentDate(retrait.date_vente)} · {retrait.vendeur || '—'}
              </p>
            </div>
            <div className="font-bold text-[var(--rm-red-light)] text-lg">
              {Number(retrait.prix_total ?? retrait.total ?? 0).toFixed(2)} €
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}
